import canBudget from '../can/budget';
import canEdit from '../can/edit';
import canManage from '../can/manage';

/**
 * @param {Object} me
 * @param {Object} permissions
 * @returns {Object}
 */
export default function getModel(me, permissions) {
  return {
    budget: canBudget(me, permissions),
    edit: canEdit(me, permissions),
    manage: canManage(me, permissions),
  };
}
